import { useUpdateModuleRelationMutation } from "@me-team/host/main/Modules/graphql/modules.hooks";
import { useCallback } from "react";
import { ModuleInputType } from "@me-team/host/main/graphql/types";
import { useApolloClient } from "@apollo/client";
import { isRefetchBranches } from "@me-team/host/main/branches/state";

export const useUpdateModules = () => {
    const client = useApolloClient();

    const [updateCompanyModuleRelation] = useUpdateModuleRelationMutation();
    return useCallback(
        async (companyId: number, updates: ModuleInputType[], branchId: number) => {
            for (const input of updates) {
                await updateCompanyModuleRelation({ variables: { companyId, input, branchId } });
            }

            await client.refetchQueries({
                include: ["getCompanyAndRole", "GetCompanyModules"],
            });
            isRefetchBranches(true);
        },
        [updateCompanyModuleRelation, client]
    );
};
